import { render, staticRenderFns } from "./EditTabAdminAccount.vue?vue&type=template&id=5543722f"
import script from "./EditTabAdminAccount.vue?vue&type=script&lang=js"
export * from "./EditTabAdminAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports